import { VATs } from "../../../redux/settingsSlice";
import store from "../../../redux/store";
import { detailsFinalSum, vatString, detailsFinalVat, detailSum, detailVat } from "../TableSums";

export default function buildDetails(details) {
    const partsVat = store.getState().settings.vats[VATs.parts];
    const showVat = partsVat.active;

    const detailsArray = [
        [
            {
                text: 'Наименование запчасти (материала)',
                bold: true
            },
            {
                text: 'Цена за ед.',
                alignment: 'center',
                bold: true
            },
            {
                text: 'Кол-во',
                alignment: 'center',
                bold: true
            },
            showVat && {
                text: 'НДС',
                alignment: 'center',
                bold: true
            },
            {
                text: 'Сумма',
                alignment: 'right',
                bold: true
            }
        ].filter(Boolean),
    ]

    details.forEach(item => {
        detailsArray.push(
            [
                {
                    text: item.job.detail.part_name,
                },
                {
                    text: item.job.detail.price,
                    alignment: 'center'
                },
                {
                    text: item.job.detail.amount,
                    alignment: 'center'
                },
                showVat && {
                    text: vatString(detailVat(item.job.detail)),
                    alignment: 'center'
                },
                {
                    text: detailSum(item.job.detail, { useVat: true }).toFixed(2),
                    alignment: 'right'
                },
            ].filter(Boolean)
        );
    });
    
    return [
        {
            text: 'Запасные части и материалы',
            alignment: 'center',
            style: 'subheader'
        },
        {
            layout: 'lightHorizontalLines',
            table: {
                headerRows: 1,
                widths: ['*', 65, 65, showVat && 40, 65].filter(Boolean),
                body: detailsArray
            }
        },
        {
            columns: [
                {
                    width: '60%',
                    text: '',
                },
                {
                    width: '40%',
                    stack: [
                        {
                            columns: [
                                {
                                    width: '50%',
                                    text: 'Итого з/ч и материалов:'
                                },
                                {
                                    width: '50%',
                                    text: '\n' + detailsFinalSum({ useVat: true }).toFixed(2) + ' руб.', 
                                    bold: true,
                                    alignment: 'right'
                                }
                            ]
                        },
                        {
                            columns: [
                                {
                                    width: '50%',
                                    text: 'НДС:'
                                },
                                {
                                    width: '50%',
                                    text: detailsFinalVat().toFixed(2) + ' руб.',
                                    alignment: 'right'
                                }
                            ]
                        }
                    ],
                },
            ]
        }
    ];
}